export default "__VITE_ASSET__DNrazU_g__"